import { render, staticRenderFns } from "./bchabc.vue?vue&type=template&id=e2ef50fe&"
import script from "./bchabc.vue?vue&type=script&lang=js&"
export * from "./bchabc.vue?vue&type=script&lang=js&"
import style0 from "./bchabc.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports